// date.js
// 注意：这里假设不再需要 `kebabCase` 从 "element-ui/src/utils/util" 导入，因为它在代码中未使用

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export function str2Date(dateStr, separator) {
  if (!separator) {
    separator = "-";
  }
  let dateArr = dateStr.split(separator);
  let year = parseInt(dateArr[0]);
  let month;
  // 处理月份为04这样的情况
  if (dateArr[1].indexOf("0") === 0) {
    month = parseInt(dateArr[1].substring(1));
  } else {
    month = parseInt(dateArr[1]);
  }
  let day = parseInt(dateArr[2]);
  let date = new Date(year, month - 1, day);
  return date;
}

// 添加日期范围，只保留年月日
export function addDateRange(params, dateRange) {
  let search = params;
  search.beginTime = "";
  search.endTime = "";

  if (dateRange && dateRange.length === 2) {
    // 假设 dateRange[0] 和 dateRange[1] 都是 "YYYY-MM-DD" 格式的字符串
    search.beginTime = formatDate(str2Date(dateRange[0]), "yyyy-MM-dd") + " 00:00:00";
    search.endTime = formatDate(str2Date(dateRange[1]), "yyyy-MM-dd") + " 23:59:59";
  }
  return search;
}


// WEBPACK FOOTER //
// ./src/utils/date.js